import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "timer-wrapper"
};
const _hoisted_2 = {
  class: "timer-container"
};
const _hoisted_3 = {
  class: "timer-content"
};
const _hoisted_4 = {
  class: "timer-unit"
};
const _hoisted_5 = {
  class: "timer-value"
};
const _hoisted_6 = {
  class: "timer-unit"
};
const _hoisted_7 = {
  class: "timer-value"
};
const _hoisted_8 = {
  class: "timer-unit"
};
const _hoisted_9 = {
  class: "timer-value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vue_countdown = _resolveComponent("vue-countdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vue_countdown, {
    ref: "countdownComponent",
    "auto-start": false,
    time: _ctx.overallMilliseconds,
    onEnd: _ctx.onCountdownEnd
  }, {
    default: _withCtx(({
      hours,
      minutes,
      seconds,
      totalMilliseconds
    }) => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(hours), 1), _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "timer-label"
    }, "Hours", -1))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(minutes), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "timer-label"
    }, "Minutes", -1))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(seconds), 1), _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "timer-label"
    }, "Seconds", -1))])]), _createElementVNode("div", {
      class: "progress-line",
      style: _normalizeStyle({
        width: _ctx.progressPercentage(totalMilliseconds) + '%'
      })
    }, null, 4)])]),
    _: 1
  }, 8, ["time", "onEnd"])]);
}